import styled from '@emotion/styled';
import Text from '~/components/Text';

export const DropdownWrapper = styled.div`
  width: 300px;
  background-color: var(--white);
  border: 1px solid var(--border1);
  border-radius: 8px;
  box-shadow: 0px 32px 64px -12px #0c102124;
  z-index: 200 !important;
`;

export const EachSection = styled.div`
  border-bottom: 1px solid var(--border1);

  &:last-of-type {
    border-bottom: none;
  }
`;

export const ListItem = styled.div`
  padding: 8px 16px;
  height: 40px;
  &:hover {
    background-color: var(--hover1);
  }
`;

export const ItemData = styled(Text)<{
  isEnabled: boolean;
}>``;

export const IconContainer = styled.div`
  padding-right: 8px;
`;
